export default "__VITE_ASSET__ZPjtsDlC__"